module.exports = __webpack_public_path__ + "images/moonshot/fender.88a465fda1c46dad3ad3.png";